export function getThemeDefaultCategories(theme: string): Record<string, string> {
  const themeCategoriesMap: Record<'fantasy' | 'scifi' | 'police' | 'horror', Record<string, string>> = {
    fantasy: {
      magicSystem: 'Magic System',
      races: 'Races',
      religions: 'Religions',
    },
    scifi: {
      technology: 'Technology',
      planets: 'Planets',
    },
    police: {
      caseFiles: 'Case Files',
    },
    horror: {
      creatures: 'Creatures',
      rules: 'Rules',
    },
  };
  
  if (theme === 'fantasy') return themeCategoriesMap.fantasy;
  if (theme === 'scifi') return themeCategoriesMap.scifi;
  if (theme === 'police') return themeCategoriesMap.police;
  if (theme === 'horror') return themeCategoriesMap.horror;
  
  return {};
}
